import React from "react";
import { testimonials } from "../data/siteData";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./Testimonials.css";

export default function Testimonials() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".testimonials__card"), {
      ...revealUp(null, el.querySelector(".testimonials__grid")),
      stagger: 0.12,
    });
  }, []);

  return (
    <section className="testimonials section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">What Clients Say</span>
        <h2 className="testimonials__title">TRUSTED ACROSS KERALA</h2>

        <div className="testimonials__grid">
          {testimonials.map((t) => (
            <blockquote className="testimonials__card" key={t.id}>
              <p className="testimonials__quote">&ldquo;{t.quote}&rdquo;</p>
              <footer>
                <span className="testimonials__name">{t.name}</span>
                <span className="testimonials__location">{t.location}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
